import * as React from "react";
import { connect } from "react-redux";
// import CompetitionApi from '../../data/api/competitionApi'
// import { ICompetition } from '../../types/competition/Competition'
import { useParams } from "react-router";
import { Alert, Card, Select, TextInput } from "@mantine/core";
import TeamApi from "../../data/api/teamApi";
import { ITeam } from "../../types/team/Team";
import { CenteredLoader } from "../common/loader";

export interface TeamManagerProps {
  teamId?: string | null;
}

export interface TeamManagerState {
  teamId: string | null;
  team?: ITeam;

  editingColor: boolean;

  loading: boolean;
  error?: string | null;
}

const colors = [
  "Black",
  "White",
  "Red",
  "Blue",
  "Light-blue",
  "Green",
  "Orange",
  "Yellow",
  "Purple",
  "Pink",
].sort();

const colSet = new Set(colors.map((c) => c.toLowerCase()));

const TeamManager: React.FunctionComponent<TeamManagerProps> = (props) => {
  const [team, setTeam] = React.useState<ITeam | undefined>(undefined);
  const [isEditingColor, setIsEditingColor] = React.useState<boolean>(false);
  const [loading, setLoading] = React.useState<boolean>(false);
  const [error, setError] = React.useState<string | null>(null);

  const matchedTeamId = useParams().teamId;

  const teamId = props.teamId || matchedTeamId;

  if (!teamId) {
    return (
      <Alert color="red">
        This page failed to load, please go back and try again
      </Alert>
    );
  }

  React.useEffect(() => {
    setError(null);
    TeamApi.getTeamById(teamId)
      .then((team) => {
        setTeam(team);
      })
      .catch((er) => setError(er));
  }, [teamId]);

  const updateTeam = (newTeamPartial: Partial<ITeam>) => {
    const originalTeam = team;
    if (!team) return;
    setLoading(true);
    setTeam({ ...team, ...newTeamPartial });
    return TeamApi.updateTeam({ _id: team._id, ...newTeamPartial })
      .then((_) => setLoading(false))
      .catch((er) => {
        setError(er.message);
        setLoading(false);
        // set back to original team, reverting the change
        setTeam(originalTeam);
      });
  };

  return (
    <div>
      <Card padding="md">
        {team && (
          <>
            <h2>{team.name}</h2>

            <label>Color</label>
            <Select
              value={team.color || ""}
              placeholder="Specify a color"
              name="color"
              onChange={(value) =>
                updateTeam({ color: value })
              }
              data={[
                ...((!team.color) ? [{ value: "", label: "Specify a color" }] : []),
                ...(team.color && !colSet.has(team.color?.toLowerCase()) ? [{ value: team.color.toLowerCase(), label: team.color }] : []),
                ...colors.map((c) => ({
                  value: c.toLowerCase(),
                  label: c
                }))
              ]}
            />
            <br />

            <hr />
          </>
        )}

        {loading && <CenteredLoader />}
        {error && (
          <Alert color="red">
            Failed to {team ? "update" : "get"} team: {error}
          </Alert>
        )}
      </Card>
    </div>
  );
};

const mapState2Props = (state) => ({
  associations: Object.values(state.associations.map),
});

export default connect(mapState2Props)(TeamManager);
